import React, {useState} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import SlidingPane from 'react-sliding-pane'
import * as rest from '../../services'
import {showErrorToast, showSuccessToast} from '../../state/toasts'
import UserProfileForm from './UserProfileForm'
import {getLists} from '../../state/lists'
import {User} from "../../api";
import {ICONS} from "../../components";

export type EditProfilePaneProps = {
    OnSuccess: (u: User) => void
    user?: User
}

const EditProfilePane = ({OnSuccess, user}: EditProfilePaneProps) => {
    const dispatch = useDispatch()
    const {country, states} = useSelector((state) => state.lists)
    const [isPaneOpen, setIsPaneOpen] = useState(false)
    
    const onUpdate = (values: Partial<User>) => {
        if (!user?.url) return
        
        const promise = new rest.UserService(user.url).makePutRequest(values)
        promise
            .then((response) => {
                dispatch(
                    showSuccessToast(
                        'Updated user profile.',
                        `${response.first_name} ${response.last_name}'s profile has been updated`
                    )
                )
                OnSuccess && OnSuccess(response.data)
                setIsPaneOpen(false)
            })
            .catch((errors) => {
                dispatch(
                    showErrorToast(
                        'Could not update user profile.',
                        JSON.stringify(errors.response ? errors.response.data : errors)
                    )
                )
            })
    }

    const loadOptions = () => {
        !country && dispatch(getLists('COUNTRY'))
        !states && dispatch(getLists('STATES'))
    }
    return (
        <>
            <ReactBootstrap.Button
                variant="link"
                className="text-dark"
                onClick={(e) => {
                    e.stopPropagation()
                    setIsPaneOpen(true)
                }}
            >
                {ICONS.EDIT} Edit
            </ReactBootstrap.Button>

            <SlidingPane
                overlayClassName="on-top"
                isOpen={isPaneOpen}
                onAfterOpen={loadOptions}
                title="Edit Profile"
                onRequestClose={() => {
                    setIsPaneOpen(false)
                }}
            >
                {isPaneOpen && (
                    <UserProfileForm 
                        key={user?.id || 'new-user'} 
                        onSubmit={onUpdate} 
                        initialValues={user} 
                    />
                )}
            </SlidingPane>
        </>
    )
}

export default EditProfilePane
